import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=3c05b1b2&scoped=true&"
import script from "./Watchlist.vue?vue&type=script&lang=js&"
export * from "./Watchlist.vue?vue&type=script&lang=js&"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=3c05b1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c05b1b2",
  null
  
)

export default component.exports